import { Navigate } from 'react-router-dom';

export default function PrivateRoute({ children }) {
  const token = localStorage.getItem('vizumToken');

  if (!token) {
    return <Navigate to="/login" />;
  }

  return children;
}
